import Image from 'next/image';
import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexCenterAligned } from '@/styles/common';

import { AvatarSize, getNameFontSize } from './Avatar.helpers';

const boxSize = (size: AvatarSize) =>
  typeof size === 'number'
    ? css`
        width: ${size}px;
        height: ${size}px;
      `
    : css`
        width: ${size.large}px;
        height: ${size.large}px;

        @media (max-width: ${CONTAINER_MAX[size.from]}) {
          width: ${size.base}px;
          height: ${size.base}px;
        }
      `;

const nameFontSize = (size: AvatarSize) =>
  typeof size === 'number'
    ? css`
        font-size: ${getNameFontSize(size)}px;
      `
    : css`
        font-size: ${getNameFontSize(size.large)}px;

        @media (max-width: ${CONTAINER_MAX[size.from]}) {
          font-size: ${getNameFontSize(size.base)}px;
        }
      `;

export const AvatarWrapper = styled.div<{
  $size: AvatarSize;
  $withImage?: boolean;
}>`
  ${flexCenterAligned};
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ $withImage }) => !$withImage && 'var(--bg-tertiary)'};
  position: relative;
  ${({ $size }) => boxSize($size)}
`;

export const AvatarImage = styled(Image)`
  object-fit: cover;
`;

export const AvatarName = styled(Typography).attrs({
  htmlTag: 'p'
})<{
  $size: AvatarSize;
}>`
  ${({ $size }) => nameFontSize($size)}
  font-weight: 700;
  color: var(--title-snackbar);
`;
